import dayjs from 'dayjs';
import { StringUtil } from "@brandless/tsutility";

export class FileFolderNameExtensions {
    // private static InvalidChars: Array<number> = new Array<number>('"'.charCodeAt(0), '#'.charCodeAt(0), '$'.charCodeAt(0), '*'.charCodeAt(0), ':'.charCodeAt(0), '<'.charCodeAt(0), '>'.charCodeAt(0), '?'.charCodeAt(0), '/'.charCodeAt(0), '\\'.charCodeAt(0), '|'.charCodeAt(0));
    private static InvalidChars: Array<number> = new Array<number>('"'.charCodeAt(0), '*'.charCodeAt(0), ':'.charCodeAt(0), '<'.charCodeAt(0), '>'.charCodeAt(0), '?'.charCodeAt(0), '/'.charCodeAt(0), '\\'.charCodeAt(0), '|'.charCodeAt(0));
    private static InvalidNames: Array<string> = new Array<string>(`.lock`, `CON`, `PRN`, `AUX`, `NUL`, `COM0`, `COM1`, `COM2`, `COM3`, `COM4`, `COM5`, `COM6`, `COM7`, `COM8`, `COM9`, `LPT0`, `LPT1`, `LPT2`, `LPT3`, `LPT4`, `LPT5`, `LPT6`, `LPT7`, `LPT8`, `LPT9`, `_vti_`, `desktop.ini`);
    private static InvalidStartString: string = "~";
    private static InvalidStartStrings: Array<string> = new Array<string>(`~$`);
    private static InvalidContain: string = `_vti_`;

    public static EnsureValidName(name: string | null, trimEnd: boolean = true, formatEmptyValue: boolean = true): string | null {
        if (!name || StringUtil.IsNullOrWhiteSpace(name)) {
            return formatEmptyValue ? dayjs().format("YYYY-MM-DD HH[h]mm[m]ss[s]") : "";
        }

        let tmpName: string = "".concat(...(StringUtil.SplitAndRemoveEmptyEntries(name, FileFolderNameExtensions.InvalidChars)));
        tmpName = StringUtil.TrimStart(tmpName, FileFolderNameExtensions.InvalidStartString);
        if (trimEnd) tmpName = tmpName.trim(); else tmpName = tmpName.trimStart();
        tmpName = StringUtil.Replace(tmpName, FileFolderNameExtensions.InvalidContain, ``);
        for (let invalidStartString_index_ = 0, invalidStartString_source_ = FileFolderNameExtensions.InvalidStartStrings; invalidStartString_index_ < invalidStartString_source_.length; invalidStartString_index_++) {
            let invalidStartString = invalidStartString_source_[invalidStartString_index_];
            if (tmpName.startsWith(invalidStartString))
                tmpName = tmpName.substr(invalidStartString.length - 1);
        }
        if (trimEnd) tmpName = tmpName.trim(); else tmpName = tmpName.trimStart();
        if (StringUtil.IsNullOrWhiteSpace(tmpName) || ((FileFolderNameExtensions.InvalidNames).filter(invalidName => tmpName == invalidName).length > 0)) {
            tmpName = dayjs().format("YYYY-MM-DD HH[h]mm[m]ss[s]");
        }

        return tmpName;
    }
}

export const formatNameFieldValue = (newValue: string): string => {
    if (newValue) {
        newValue = newValue.trimStart();
        if (!newValue || StringUtil.IsNullOrWhiteSpace(newValue)) {
            return dayjs().format("YYYY-MM-DD HH[h]mm[m]ss[s]");
        }
        return newValue;
    }
    return "";
}